import auth from 'src/router/middleware/authentification/auth.js'
import channelLiteRedirect from 'src/router/middleware/channels/channel/channelLiteRedirect.js'

const ChatList = () => import('src/views/Channels/Chat/ChatList.vue')
const ChannelCreationStart = () => import('src/views/Channels/Channel/Creation/ChannelCreationStart.vue')
const ChannelCreationConfirm = () => import('src/views/Channels/Channel/Creation/ChannelCreationConfirm.vue')
const ChannelCreationAddUsers = () => import('src/views/Channels/Channel/Creation/ChannelCreationAddUsers.vue')
const ChannelCreationWrapper = () => import('src/views/Channels/Channel/Creation/ChannelCreationWrapper.vue')
const ChannelWrapper = () => import('src/views/Channels/Channel/ChannelWrapper.vue')
const Chat = () => import('src/views/Channels/Chat/Chat.vue')
const ChatCreateConference = () => import('src/views/Channels/Chat/ChatCreateConference.vue')
const ChannelEdit = () => import('src/views/Channels/Channel/Editing/ChannelEdit.vue')
const ChannelEditWrapper = () => import('src/views/Channels/Channel/Editing/ChannelEditWrapper.vue')
const ChannelEditUsers = () => import('src/views/Channels/Channel/Editing/ChannelEditUsers.vue')
const ChannelUserSearch = () => import('src/views/Channels/Channel/ChannelUserSearch.vue')
const ChannelSearch = () => import('src/views/Channels/Channel/ChannelSearch.vue')
const ChannelCreationList = () => import('src/views/Channels/Channel/Creation/ChannelCreationList.vue')
const ChatConferenceHint = () => import('src/views/Channels/Chat/ChatConferenceHint.vue')
const ChannelNews = () => import('src/views/Channels/Channel/ChannelNews.vue')
const TeacherParentChannelWrapper = () => import('src/views/Channels/Channel/Creation/TeacherParentChannelWrapper.vue')
const TeacherParentGrades = () => import('@/views/Channels/Channel/Creation/TeacherParentGradeSelection.vue')
const TeacherParentSettings = () => import('src/views/Channels/Channel/Creation/TeacherParentSettings.vue')

export default [
  {
    path: '/channels',
    component: ChatList,
    name: 'channels',
    meta: {
      middleware: [auth, channelLiteRedirect],
      group: 'channels',
      layout: 'sdui',
      headerText: 'global.headers.chats',
      enableSwReload: true
    }
  },
  {
    path: '/channels/type/:userId?',
    component: ChannelSearch,
    name: 'channels-type',
    meta: {
      middleware: [auth],
      group: 'channels',
      headerText: 'global.headers.chats'
    }
  },
  {
    path: '/channels/:id',
    component: ChannelWrapper,
    name: 'channel-single-wrapper',
    meta: {
      middleware: [auth],
      group: 'channels',
      headerText: 'global.headers.chat'
    },
    children: [
      {
        path: 'chat',
        component: Chat,
        name: 'channel-single-chat',
        meta: {
          middleware: [auth],
          group: 'channels',
          headerText: 'global.headers.chat',
          preventAutomaticScreenReaderFocus: true
        }
      }
    ]
  },
  {
    path: '/channels/create',
    component: ChannelCreationWrapper,
    meta: {
      middleware: [auth],
      group: 'channels',
      headerText: 'global.headers.new_chat_group'
    },
    children: [
      {
        path: 'start',
        component: ChannelCreationStart,
        name: 'create-channel-start',
        meta: {
          middleware: [auth],
          group: 'channels',
          progress: 1,
          transitionPoint: 1,
          headerText: 'global.headers.new_chat_group_name'
        }
      },
      {
        path: 'users',
        component: ChannelCreationAddUsers,
        name: 'create-channel-users',
        meta: {
          middleware: [auth],
          group: 'channels',
          progress: 2,
          transitionPoint: 2,
          headerText: 'global.headers.new_chat_group_participants'
        }
      },
      {
        path: 'finish',
        component: ChannelCreationConfirm,
        name: 'create-channel-finish',
        meta: {
          middleware: [auth],
          group: 'channels',
          progress: 3,
          transitionPoint: 3,
          headerText: 'global.headers.new_chat_group'
        }
      }
    ]
  },
  {
    path: '/channels/teacher-parents/create',
    component: TeacherParentChannelWrapper,
    meta: {
      middleware: [auth],
      group: 'channels',
    },
    children: [
      {
        path: 'grade-selection',
        component: TeacherParentGrades,
        name: 'create-teacher-parent-channel-grade-selection',
        meta: {
          progress: 1,
          transitionPoint: 2,
        }
      },
      {
        path: 'settings',
        component: TeacherParentSettings,
        name: 'create-teacher-parent-channel-settings',
        meta: {
          progress: 2,
          transitionPoint: 2,
        }
      },
    ]
  },
  {
    path: '/channels/:id/edit/:view?',
    component: ChannelEditWrapper,
    meta: {
      middleware: [auth]
    },
    children: [
      {
        path: '',
        component: ChannelEdit,
        name: 'edit-channel-general',
        meta: {
          transitionPoint: 9,
          headerText: 'global.headers.chat_information'
        }
      },
      {
        path: 'users',
        component: ChannelEditUsers,
        name: 'edit-channel-users',
        meta: {
          transitionPoint: 10,
          headerText: 'global.headers.chat_members'
        }
      },
      {
        path: 'search',
        component: ChannelUserSearch,
        name: 'search-channel-users',
        meta: {
          transitionPoint: 11,
          headerText: 'global.headers.chat_members'
        }
      }
    ]
  },
  {
    path: '/channels/:channelId/start-conference',
    component: ChatCreateConference,
    name: 'start-video-conference',
    meta: {
      middleware: [auth],
      group: 'channels',
      headerText: 'global.headers.create_conference'
    }
  },
  {
    path: '/channels/:channelId/join-conference/:conferenceUuid',
    component: ChatConferenceHint,
    name: 'join-video-conference',
    meta: {
      middleware: [auth],
      group: 'channels',
      headerText: 'global.headers.join_conference'
    }
  },
  {
    path: '/channels/creation/list',
    name: 'channel-creation-list',
    component: ChannelCreationList,
    meta: {
      middleware: [auth],
      headerText: 'global.headers.new_chat'
    }
  },
  {
    path: '/channel/:id/news',
    component: ChannelNews,
    name: 'channel-news',
    meta: {
      middleware: [auth],
      group: 'channels',
      headerText: 'global.headers.news_detail_page'
    }
  }
]
